import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconTag = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M13 23.09C12.47 23.09 11.96 22.88 11.59 22.5L3.58 14.5C3.2 14.12 3 13.62 3 13.09V6.5C3 5.4 3.9 4.5 5 4.5H11.58C12.11 4.5 12.62 4.71 12.99 5.08L20.99 13.08C21.77 13.86 21.77 15.13 20.99 15.91L14.4 22.5C14.02 22.88 13.52 23.09 12.99 23.09H13ZM11.58 6.5H5V13.09L13 21.09L19.59 14.5L11.58 6.5Z" }),
            React.createElement("path", { d: "M7 9.5C7.55228 9.5 8 9.05228 8 8.5C8 7.94772 7.55228 7.5 7 7.5C6.44772 7.5 6 7.94772 6 8.5C6 9.05228 6.44772 9.5 7 9.5Z" }))));
};
